import { useCallback, useEffect } from 'react';
import { useRepeatableListEditor } from '../../../repeat-controller/useRepeatableListEditor.ts';
import { type IButtonActionLogicComponentProps } from '../common/IButtonActionLogicComponentProps.ts';
import { type IButtonActionListAdd } from '../IButtonAction.ts';

/**
 * Componente "logico" per la gestione dell'azione dell'aggiunta di un elemento a una lista.
 * Non renderizza nulla ma permette di gestire l'azione iscrivendosi all'evento onClick
 * del pulsante padre.
 */
export function ButtonActionListAddLogicComponent(
  props: IButtonActionLogicComponentProps<IButtonActionListAdd>,
) {
  const { action, buttonWidgetOptions, onClickSubject } = props;

  const { handleAdd } = useRepeatableListEditor(
    buttonWidgetOptions.name,
    action.listReference,
  );

  const handleAction = useCallback(() => {
    if (!action.listReference) {
      console.warn(`ListAddActionComponent: listReference is not defined`);
      return;
    }
    handleAdd();
  }, [action.listReference, handleAdd]);

  useEffect(() => {
    const subscription = onClickSubject.subscribe(handleAction);
    return () => subscription.unsubscribe();
  }, [onClickSubject, handleAction]);

  return null;
}
